'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiDownload3 = function (_React$Component) {
    _inherits(AiDownload3, _React$Component);

    function AiDownload3() {
        _classCallCheck(this, AiDownload3);

        return _possibleConstructorReturn(this, (AiDownload3.__proto__ || Object.getPrototypeOf(AiDownload3)).apply(this, arguments));
    }

    _createClass(AiDownload3, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M48,38.768v6.155c0,0.513-0.179,0.951-0.538,1.308c-0.359,0.358-0.795,0.538-1.307,0.538H17.846 c-0.512,0-0.949-0.181-1.307-0.538C16.18,45.873,16,45.436,16,44.923v-6.155c0-0.511,0.18-0.947,0.538-1.306 c0.359-0.36,0.795-0.538,1.307-0.538h8.943l2.597,2.615c0.744,0.719,1.615,1.077,2.616,1.077c1.001,0,1.871-0.358,2.616-1.077 l2.615-2.615h8.924c0.512,0,0.949,0.179,1.307,0.538C47.821,37.822,48,38.257,48,38.768z M41.751,27.826 c0.218,0.526,0.127,0.976-0.269,1.346l-8.616,8.616c-0.231,0.244-0.52,0.366-0.866,0.366s-0.635-0.122-0.866-0.366l-8.616-8.616 c-0.398-0.37-0.488-0.82-0.269-1.346c0.218-0.501,0.596-0.749,1.135-0.749h4.923V18.46c0-0.332,0.122-0.622,0.365-0.864 c0.244-0.244,0.532-0.366,0.866-0.366h4.923c0.333,0,0.622,0.122,0.866,0.366c0.244,0.243,0.366,0.532,0.366,0.864v8.617h4.923 C41.154,27.078,41.532,27.326,41.751,27.826z M40.25,43.943c0.244-0.244,0.366-0.532,0.366-0.867c0-0.332-0.122-0.62-0.366-0.864 c-0.243-0.242-0.532-0.364-0.866-0.364c-0.333,0-0.622,0.122-0.864,0.364c-0.244,0.244-0.366,0.532-0.366,0.864 c0,0.334,0.122,0.623,0.366,0.867c0.243,0.244,0.531,0.366,0.864,0.366C39.718,44.309,40.007,44.187,40.25,43.943z M45.173,43.943 c0.244-0.244,0.366-0.532,0.366-0.867c0-0.332-0.122-0.62-0.366-0.864c-0.243-0.242-0.532-0.364-0.864-0.364 c-0.334,0-0.623,0.122-0.866,0.364c-0.244,0.244-0.366,0.532-0.366,0.864c0,0.334,0.122,0.623,0.366,0.867 c0.243,0.244,0.531,0.366,0.866,0.366C44.641,44.309,44.93,44.187,45.173,43.943z' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '16 16 32 32';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-download-3', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-download-3', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiDownload3;
}(_react2.default.Component);

exports.default = AiDownload3;